//Begin Google Analytics Enhanced Ecommerce JS

function onCollectionPageLoad(collectionTitle, collectionId, collectionHandle, collectionSortBy, collectionDefaultSortBy) {
    convertData.collection.name = collectionTitle;
	convertData.collection.id = collectionId;
	convertData.collection.handle = collectionHandle;
	if (collectionSortBy != "") {
		convertData.collection.sortBy = collectionSortBy;
	} else {
		convertData.collection.sortBy = collectionDefaultSortBy;
	}
	convertData.lastAction.collectionViewed = sessionStorage.getItem('lastViewedCollection');
	//**need to revisit**
	sessionStorage.setItem('lastViewedCollection', collectionTitle);
	dataLayer.push({
		"event" : "listView"
	});
}

function onSearchResultsLoad(searchQueryTitle) {
  sessionStorage.setItem('lastViewedCollection', searchQueryTitle);
  dataLayer.push({
    "event" : "listView"
  });
}

function addCollectionClickListener() {
	//instead of adding an event listener to every product in a list, add it to the document and check for when a click event matches a product click or add to cart.
	document.addEventListener("click", function(event) {
		//checking for a product click - ***site specific***
    	if (event.target.matches('.grid-view-item__image')) {
      		var clickedProductId = event.target.dataset.productId;
      		//find the matching product based on all the impressions on the page and call the collectionActions function to add the clicked product to convertData
			for (var i = 0; i < convertData.product.productImpressionInfo.length; i++) {
        		if (clickedProductId == convertData.product.productImpressionInfo[i].id) {
          			collectionActions(convertData.product.productImpressionInfo[i], "click");
        		}
      		}
    	}
    	//checking for an add to cart - ***site specific***
    	if (event.target.matches('input.btn')) {
      		var clickedProductId = event.target.dataset.productId;
      		//find the matching product based on all the impressions on the page and call the collectionActions function to add the clicked product to convertData
      		for (var i = 0; i < convertData.product.productImpressionInfo.length; i++) {
              if (clickedProductId == convertData.product.productImpressionInfo[i].id) {
                  collectionActions(convertData.product.productImpressionInfo[i], "add");
              }
      		}
    	}
	}, false); 
}

function addSearchResultsClickListener() {
  document.addEventListener("click", function(event) {    
    //checking for a product click - ****site specific***
    if (event.target.matches('.list-view-item__title') || event.target.matches('.list-view-item__image') || event.target.matches('.list-view-item__title-column') || event.target.matches('.list-view-item')) {
      var clickedProductId = event.target.dataset.productId;
      //find the matching product basedo n all the impressions on the page and call the collectionActions function to add the clicked product to convertData
      for(var i = 0; i < convertData.product.productImpressionInfo.length; i++) {
        if (clickedProductId == convertData.product.productImpressionInfo[i].id) {
          collectionActions(convertData.product.productImpressionInfo[i], "click");
        }
      }
    }
  }, false);
}

function collectionActions(clickedProduct, productAction) {
	convertData.product.productClickInfo.push(clickedProduct);
    convertData.lastAction.productClicked = convertData.product.productClickInfo[convertData.product.productClickInfo.length - 1];
	//**need to revisit**
	sessionStorage.setItem('lastClickedProduct', JSON.stringify(convertData.lastAction.productClicked));
	dataLayer.push({
		"event" : "listClick"
	});
	//on ATC from list, we want to fire a click and an add
	if (productAction == "add") {
		convertData.lastAction.addedToCart = clickedProduct;
		convertData.lastAction.addedToCart.quantity = 1;
		dataLayer.push({
			"event" : "listAdd"
		});
  	}
}

function onProductPageLoad(productTitle, productId, productSku, productHandle, productType, productBrand, productPrice, productVariant) {
  	var self = this;
    // commented out because of console error 
    // Uncaught TypeError: self._getVariantFromOptions is not a function
  	// self._getVariantFromOptions();
	console.log("---"+self);
  
  	//Prevents sending the default value to GA
  	if(productVariant == "Default Title") {
    	productVariant = "";
  	}
	//initializing global variables that get used in theme.js and click event handler
    var selectedVariantTitle;
  	var selectedVariantPrice;
  	var selectedVariantSku;
	convertData.product.productViewInfo.push({
		name: productTitle,
		id: productId,
		sku: productSku,
		handle: productHandle,
		type: productType,
		brand: productBrand,
		price: productPrice,
		variant: productVariant
    });
	convertData.lastAction.productViewed = convertData.product.productViewInfo[convertData.product.productViewInfo.length - 1];
	//**need to revisit**
	sessionStorage.setItem('lastViewedProduct', JSON.stringify(convertData.lastAction.productViewed));
	//**need to revisit**
	convertData.lastAction.collectionViewed = sessionStorage.getItem('lastViewedCollection');
	//**need to revisit**
	convertData.lastAction.productClicked = JSON.parse(sessionStorage.getItem('lastClickedProduct'));
	dataLayer.push({
		"event" : "productDetailView"
	});
}

function addProductDetailClickListener() {
	//instead of adding an event listener directly to the ATC button, add it to the document and check for when a click event matches an add to cart.
	document.addEventListener("click", function(event) {
		//checking for an add to cart - ***site specific***
		if ((event.target.matches('.product-form__cart-submit')) || (event.target.matches('#AddToCartText-product-template'))) {
			productDetailActions(convertData.lastAction.productViewed);
		}
	}, false); 
}

function productDetailActions(addedProduct) {
	//product added to cart is the same as the product viewed on PDP, with a few unique object properties
	convertData.lastAction.addedToCart = addedProduct;
	//check if the product has a variant title, otherwise set as blank.  This value is set in theme.js
  	if (typeof selectedVariantTitle !== "undefined") {
		convertData.lastAction.addedToCart.variant = selectedVariantTitle;
    }
  	else {
      	convertData.lastAction.addedToCart.variant = "";
    }
	//check if the product has a variant sku, otherwise set as blank.  This value is set in theme.js
    if (typeof selectedVariantSku !== "undefined") {
  		convertData.lastAction.addedToCart.sku = selectedVariantSku;
    }
  	else {
      	convertData.lastAction.addedToCart.sku = addedProduct.sku;
    }
	//check if the product has a variant price, otherwise set as blank.  This value is set in theme.js
  	if (typeof selectedVariantPrice !== "undefined") {
		convertData.lastAction.addedToCart.price = selectedVariantPrice;
    }
  	else {
		convertData.lastAction.addedToCart.price = addedProduct.price;
    }
	//include quantity based on what is in the quantity box on the page - ***site specific***
	convertData.lastAction.addedToCart.quantity = parseInt(document.querySelector("#Quantity").value, 10);
	dataLayer.push({
		"event" : "pdpAdd"
	});
}

//End Google Analytics Enhanced Ecommerce JS